<p-toast position="top-left" key="tl"></p-toast>

<p-dialog [blockScroll]="true" styleClass="cre-wig-summary-commitments-configuration-menu" [dismissableMask]="true"
  [baseZIndex]="1010"
  [draggable]="false" header="Available Commitments" [modal]="true" [(visible)]="isCommitmentMenuVisible"
  (onHide)="hideCommitmentMenu()" [resizable]="false">
  <p-listbox [(ngModel)]="newCommitment" [options]="currentCommitmentMenuChoices" optionLabel="label"
    (onChange)="setUnsavedCommitment()" [style]="{ width: '100%' }">
  </p-listbox>
</p-dialog>

<p-dialog [blockScroll]="true" [dismissableMask]="true" [draggable]="false" [modal]="true"
  (onHide)="stopRecordingPlayer()" (onShow)="startRecordingPlayer()" [resizable]="false" [showHeader]="false"
  [(visible)]="isRecordingPlayerVisible">
  <audio controls (ended)="closeRecordingPlayerDialog()" playsinline #recordingPlayer>
    <source src="" type="audio/mpeg" />
  </audio>
</p-dialog>
<div class="cre-layout-content" *ngIf="isFleetLoaded && isRecordingsLoaded && isTractorLoaded" [@creFadeInOut]>
  <!-- Wig Commitments -->
  <div class="cre-wig-summary-commitments-title">Commitments</div>
  <div class="cre-wig-summary-commitments-container" (click)="displayCommitmentConfigurationForm()">
    Choose
    <fa-icon [icon]="['fal', 'edit']">
    </fa-icon>
  </div>
  <div class="p-grid p-justify-center">
    <cre-spinner [size]="'md'" [hidden]="!isLoadingCommitments"></cre-spinner>
  </div>
  <div *ngFor="let commitment of leadInformation">
    <app-commitment-container [description]="commitment.leadDescription"
      [icon]="commitment.getIcon(commitment.leadSubject)" [isCompleted]="commitment.completionStatus"
      [label]="commitment.leadSubject" (click)="displayCommitmentForm(commitment)">
    </app-commitment-container>
  </div>
  <!-- Wig Conference -->
  <div class="cre-wig-summary-conference" *ngIf="fleetWeekly !== null">
    <div class="cre-wig-summary-conference-details">
      <span class="cre-wig-summary-conference-title">{{ fleetWeekly?.fleet }} WIG Huddle</span>
      <span class="cre-wig-summary-conference-number">{{
        fleetWeekly?.conferenceNumber | phoneNumber
      }}</span>
      <div class="cre-wig-summary-conference-schedule" *ngFor="let conferenceTime of fleetWeekly?.conferenceTimes">
        <span class="cre-wig-summary-conference-weekday">
          {{ conferenceTime.conferenceDateTime | date: 'EEEE' }}
        </span>
        <span>
          {{ conferenceTime.conferenceDateTime | date: 'h:mma' }} {{ conferenceTime.timezone }}
        </span>
      </div>
    </div>
    <p-splitButton label="Huddles" [model]="recordings" (onClick)="ua.onDropdownButtonClick(null)"
      styleClass="custom-background-style" [disabled]="isViewed" #ua></p-splitButton>

    <a class="cre-desktop-hidden cre-square-button"
      (click)="creditCall(fleetWeekly?.fleetWeeklyId, fleetWeekly?.driverWeeklyId)"
      href="tel:{{ fleetWeekly?.conferenceNumber }}" *ngIf="fleetWeekly?.conferenceNumber && isNotFromPSE && !isViewed">
      <fa-icon [icon]="['fas', 'phone']"></fa-icon>
    </a>
  </div>
</div>
<div class="cre-desktop-hidden" #screenSizeDetector></div>

<!-- Commitment Configuration Sidebar -->
<p-sidebar [blockScroll]="true" (onHide)="clearSidebar()" position="bottom" [showCloseIcon]="false"
  styleClass="cre-summary-commitment-configuration-sidebar" [(visible)]="isConfigurationVisible">
  <div class="cre-summary-form-sidebar-icon" *ngIf="isConfigurationVisible">
    <fa-icon (click)="hideSidebar()" [icon]="['fal', 'times']" [size]="'3x'"> </fa-icon>
  </div>
  <ng-container *ngIf="isConfigurationVisible">
    <div class="cre-summary-form-sidebar-header">
      {{ this.configurationHeader }}
    </div>
    <div class="wig-divider"></div>
    <div class="p-grid p-justify-center">
      <cre-spinner [size]="'md'" [hidden]="!isLoadingConfiguration"></cre-spinner>
    </div>
    <div class="cre-wig-summary-commitments-configuration-body">
      <div id="commitmentsDiv" *ngFor="let commitment of configurationDetails">
        <div *ngIf="showUnsavedChanges(commitment.leadNumber)">
          <app-commitment-container [canEdit]="commitment.canChoose"
            (click)="showCommitmentMenu(commitment.leadNumber, commitment.canChoose)"
            [description]="commitment.leadDescription" [icon]="commitment.getIcon(commitment.leadSubject)"
            [isConfiguration]="true" [label]="commitment.leadSubject" [leadNumber]="commitment.leadNumber">
          </app-commitment-container>
          <div class="cre-wig-summary-commitments-configuration-default-text" *ngIf="commitment.forcedDefault">
            This commitment was chosen by your fleet manager
          </div>
        </div>
        <div *ngIf="!showUnsavedChanges(commitment.leadNumber) && commitment.leadNumber === 1">
          <app-commitment-container [canEdit]="true" (click)="showCommitmentMenu(unsavedCommitment1.leadNumber, true)"
            [description]="unsavedCommitment1.leadDescription"
            [icon]="commitment.getIcon(unsavedCommitment1.leadSubject)" [isConfiguration]="true"
            [label]="unsavedCommitment1.leadSubject" [leadNumber]="unsavedCommitment1.leadNumber">
          </app-commitment-container>
        </div>
        <div *ngIf="!showUnsavedChanges(commitment.leadNumber) && commitment.leadNumber === 2">
          <app-commitment-container [canEdit]="true" (click)="showCommitmentMenu(unsavedCommitment2.leadNumber, true)"
            [description]="unsavedCommitment2.leadDescription"
            [icon]="commitment.getIcon(unsavedCommitment2.leadSubject)" [isConfiguration]="true"
            [label]="unsavedCommitment2.leadSubject" [leadNumber]="unsavedCommitment2.leadNumber">
          </app-commitment-container>
        </div>
      </div>
      {{ this.configurationDescription }}
      <div class="cre-commitments-configuration-buttons">
        <button class="cre-commitments-configuration-button" (click)="saveCommitments()" label="SUBMIT" pButton
          type="button"></button>
        <button class="cre-commitments-configuration-button" (click)="clearSidebar()" label="CANCEL" pButton
          type="button"></button>
      </div>
    </div>
  </ng-container>
  <!--Details Spinner-->
  <div class="p-grid p-justify-center">
    <cre-spinner [size]="'md'" [hidden]="!isLoadingDetails"></cre-spinner>
  </div>
</p-sidebar>

<!-- Commitment Response Sidebar -->
<p-sidebar [blockScroll]="true" (onHide)="clearSidebar()" position="bottom" [showCloseIcon]="false"
  styleClass="cre-summary-form-sidebar" [(visible)]="isSidebarVisible">
  <div class="cre-summary-form-sidebar-icon" *ngIf="isSidebarVisible">
    <fa-icon (click)="hideSidebar()" [icon]="['fal', 'times']" [size]="'3x'"> </fa-icon>
  </div>
  <!--Commitment Form-->
  <ng-container *ngIf="isCommitmentFormVisible">
    <div class="cre-summary-form-sidebar-header">
      {{ leadSubjectTitle }}
    </div>
    <div class="wig-divider"></div>
    <div class="cre-summary-form-sidebar-body" *ngIf="!isLoadingDetails">
      <app-wig-daily-dynamic-commitment-form
        #commitmentform
        [commitmentDetails]="commitmentDetails"
        (refreshStatsEvent)="refreshStatsCall()"
        (formCompleted)="dailyCommitmentCompleted()" [leadSubject]="leadSubjectTitle"
        [leadQuestionInformation]="leadQuestionInformation"
        [tractor]="tractor"
        [leadDescription]="leadDescription"></app-wig-daily-dynamic-commitment-form>
    </div>
  </ng-container>

  <!--Details Spinner-->
  <div class="p-grid p-justify-center">
    <cre-spinner [size]="'md'" [hidden]="!isLoadingDetails"></cre-spinner>
  </div>
</p-sidebar>
